// Same phone or computer as last time: the details from their last application, kept on their own device only.
const KEY = "cx_apply_me";
const KEEP = ["applicant_name", "applicant_email", "applicant_phone", "business_name", "company_number", "industry_sector",
  "trading_years", "country", "annual_revenue_gbp", "employees", "company_address", "incorporation_date", "directors"];
const YEAR_MS = 365 * 864e5;

export function rememberMe(form) {
  try {
    const me = Object.fromEntries(KEEP.map((k) => [k, form[k]]));
    localStorage.setItem(KEY, JSON.stringify({ ...me, saved_at: Date.now() }));
  } catch { /* private browsing */ }
}

/** Their last details, or null — forgotten after a year. Years trading is worked out afresh from the incorporation date. */
export function recallMe() {
  try {
    const me = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!me?.applicant_email || Date.now() - (me.saved_at || 0) > YEAR_MS) return null;
    const inc = Date.parse(me.incorporation_date || "");
    if (!Number.isNaN(inc)) me.trading_years = String(Math.max(0, Math.floor((Date.now() - inc) / YEAR_MS)));
    return me;
  } catch { return null; }
}

export function forgetMe() {
  try { localStorage.removeItem(KEY); } catch { /* private browsing */ }
}
